import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/api/analytics/track`, {
          page: location.pathname,
          referrer: document.referrer || '',
          user_agent: navigator.userAgent
        });
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Analytics tracking failed:', error);
      }
    };

    // Track after a small delay to not block initial render
    const timer = setTimeout(trackVisit, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default PageTracker;
